
<div class="separatorCenter">
    <h2>{{integrationName}}</h2>
</div>
<div class="content" *ngIf="typeIntegration.nuInt!=15">    
    <mat-tab-group  mat-stretch-tabs="false" mat-align-tabs="start" id="tab-group" dynamicHeight >
        <mat-tab label="Configurações" id="mktpcfi" class="titleTab mktpcfi">            
            <simple-form entityName='Mktpcfi' [parentRow]="parentRow"  [condition]="condition" nodata="false" [events]="eventsSubject.asObservable()"></simple-form>
        </mat-tab>
        <mat-tab label="DE-PARA" class="titleTab">
            <simple-datagrid entityName='Mktpcid' [parentRow]="parentRowCid" forceParentRow="S"  [condition]="condition" [nodata]="false" [events]="eventsSubject.asObservable()"></simple-datagrid>            
        </mat-tab>
        <mat-tab label="Preferências do Contrato" class="titleTab">            
            <simple-datagrid *ngIf="integrationRow.codeContract != null" forceParentRow="S" entityName='Mktpcontractpref' [parentRow]="parentRowContract"  [condition]="conditionContract" [nodata]="false" [events]="eventsSubject.asObservable()"></simple-datagrid>            
        </mat-tab>
        <mat-tab label="URLS" class="titleTab">
            <simple-datagrid *ngIf="integrationRow.codeMktp != null" entityName='Mktpurls' [parentRow]="parentRowServices"  [condition]="conditionServices" [nodata]="false" [events]="eventsSubject.asObservable()"></simple-datagrid>            
        </mat-tab>
        <mat-tab label="Serviços" class="titleTab">
            <simple-datagrid *ngIf="integrationRow.codeMktp != null" entityName='Mktpservices' [parentRow]="parentRowServices"  [condition]="conditionServices" [nodata]="false" [events]="eventsSubject.asObservable()"></simple-datagrid>            
        </mat-tab>
        <mat-tab label="Retorno da Integração" class="titleTab">
            <simple-datagrid *ngIf="integrationRow.idConf != null" entityName='Mktplgi' [parentRow]="parentRowLgi"  [condition]="conditionLgi" [nodata]="true" [events]="eventsSubject.asObservable()"></simple-datagrid>            
        </mat-tab>
        <mat-tab label="Erros da Integração" class="titleTab">
            <simple-datagrid *ngIf="integrationRow.idConf != null" entityName='Mktpcfgerror' [parentRow]="parentRowError"  [condition]="conditionError" [nodata]="true" [events]="eventsSubject.asObservable()"></simple-datagrid>           
        </mat-tab>
    </mat-tab-group>     
</div>
<div class="content" *ngIf="typeIntegration.nuInt==15">
    <app-request-type-service></app-request-type-service>    
</div>
<div class="finish">
    <button mat-raised-button color="primary" (click)="finalizar($event)" cdkFocusInitial>Fechar</button>        
</div>

